// Regional data for SEO-optimized multi-location website

export const REGIONS = {
  yvelines: {
    id: "yvelines",
    slug: "/",
    name: "Yvelines",
    shortName: "78",
    fullName: "Yvelines (78) - Île-de-France",
    
    // Business location
    location: "Le Pecq (78230)",
    
    // SEO
    seo: {
      title: "Couvreur Charpentier Façadier Le Pecq (78) | BKR Toiture - Artisan Yvelines",
      description: "Artisan couvreur, charpentier et façadier à Le Pecq (78). Rénovation toiture, ravalement façade, charpente et isolation dans les Yvelines. Recherche de fuites, problème de toit, urgence toiture. Devis gratuit sous 24h. Garantie décennale.",
      keywords: "couvreur Le Pecq, charpentier Yvelines, façadier 78, rénovation toiture, ravalement façade, isolation combles, artisan couvreur Saint-Germain-en-Laye, toiture Versailles, fuite toiture 78, recherche fuite Le Pecq, problème toit Yvelines, urgence toiture, infiltration eau, tuiles cassées, gouttière bouchée, dégât des eaux, démoussage toiture, nettoyage toiture, étanchéité toiture, réparation toiture urgente, toiture qui fuit, velux, zinguerie",
      geoRegion: "FR-78",
      geoPlacename: "Le Pecq",
      geoPosition: "48.8967;2.1056",
    },
    
    // Hero content
    hero: {
      badge: "Artisan certifié • Garantie décennale",
      title: "Couvreur Charpentier",
      titleAccent: "Façadier",
      location: "à Le Pecq",
      locationAccent: "(78)",
      subtitle: "Artisan local spécialisé en toiture, charpente et ravalement de façade dans les Yvelines et en Île-de-France.",
      image: "https://images.pexels.com/photos/7476608/pexels-photo-7476608.jpeg?auto=compress&cs=tinysrgb&w=1920",
    },
    
    // About section
    about: {
      title: "Votre artisan couvreur dans les Yvelines",
      experience: "10+",
      experienceLabel: "Ans d'expérience",
      image: "https://images.unsplash.com/photo-1681049400158-0ff6249ac315?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=800",
      paragraphs: [
        "Basé à <strong>Le Pecq (78)</strong>, BKR Toiture est votre partenaire de confiance pour tous vos travaux de couverture, charpente et façade dans les Yvelines et en Île-de-France.",
        "Fort d'une expérience de plus de 10 ans dans le métier, nous mettons notre savoir-faire artisanal au service de votre patrimoine. Nous utilisons exclusivement des <strong>matériaux de qualité professionnelle</strong> pour garantir la durabilité de nos interventions.",
        "Notre engagement : une intervention rapide, un travail soigné et le respect des délais. Chaque chantier est traité avec le plus grand soin, de l'étude préalable à la finition."
      ],
    },
    
    // Service area
    serviceArea: {
      title: "Zone d'intervention",
      description: "Artisan couvreur basé à <strong>Le Pecq (78230)</strong>, nous intervenons dans tout le département des <strong>Yvelines (78)</strong> et l'ensemble de l'<strong>Île-de-France</strong> pour vos travaux de toiture, charpente et façade.",
      secondParagraph: "Notre proximité nous permet d'intervenir rapidement, que ce soit pour un devis, une urgence fuite ou des travaux planifiés. Nous connaissons parfaitement les spécificités architecturales de la région.",
      areas: [
        "Le Pecq", "Saint-Germain-en-Laye", "Le Vésinet", "Chatou",
        "Croissy-sur-Seine", "Versailles", "Poissy", "Nanterre",
        "Maisons-Laffitte", "Sartrouville", "Rueil-Malmaison", "Bougival"
      ],
      mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d83998.95410694685!2d2.0189363!3d48.8967815!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e665e0e4a9e5f3%3A0x40b82c3688c5560!2sLe%20Pecq%2C%20France!5e0!3m2!1sfr!2sfr!4v1699999999999!5m2!1sfr!2sfr",
      footerAreas: ["Le Pecq", "Saint-Germain-en-Laye", "Versailles", "Le Vésinet", "Chatou"],
      footerExtra: "Tout le 78 & Île-de-France",
    },
    
    // Structured data
    structuredData: {
      latitude: 48.8967,
      longitude: 2.1056,
      postalCode: "78230",
      addressLocality: "Le Pecq",
      addressRegion: "Yvelines",
      serviceAreas: ["Le Pecq", "Saint-Germain-en-Laye", "Le Vésinet", "Chatou", "Versailles", "Yvelines", "Île-de-France"],
    },
  },
  
  hauteSavoie: {
    id: "haute-savoie",
    slug: "/haute-savoie",
    name: "Haute-Savoie",
    shortName: "74",
    fullName: "Haute-Savoie (74) - Genève",
    
    // Business location
    location: "Annecy (74000)",
    
    // SEO
    seo: {
      title: "Couvreur Charpentier Annecy & Genève | BKR Toiture - Artisan Haute-Savoie (74)",
      description: "Artisan couvreur spécialiste climat alpin à Annecy, Annemasse et Genève. Expert toiture montagne, charpente savoyarde, ravalement façade. Recherche de fuites, problème de toit, urgence toiture. Devis gratuit.",
      keywords: "couvreur Haute-Savoie, couvreur Annecy, couvreur Genève, charpentier Annecy, ravalement façade Haute-Savoie, toiture montagne, couvreur Annemasse, charpente savoyarde, toiture Thonon-les-Bains, fuite toiture 74, recherche fuite Annecy, problème toit Haute-Savoie, urgence toiture montagne, infiltration eau toiture, tuiles cassées neige, gouttière bouchée, dégât des eaux, démoussage toiture, étanchéité toiture alpine, réparation toiture urgente, toiture qui fuit, zinguerie, velux",
      geoRegion: "FR-74",
      geoPlacename: "Annecy",
      geoPosition: "45.8992;6.1294",
    },
    
    // Hero content
    hero: {
      badge: "Spécialiste climat alpin • Garantie décennale",
      title: "Couvreur Charpentier",
      titleAccent: "Alpin",
      location: "Annecy & Genève",
      locationAccent: "(74)",
      subtitle: "Expert toiture et charpente en climat de montagne. Intervention en Haute-Savoie, région d'Annecy, Annemasse et Grand Genève.",
      image: "https://images.pexels.com/photos/2832034/pexels-photo-2832034.jpeg?auto=compress&cs=tinysrgb&w=1920",
    },
    
    // About section
    about: {
      title: "Expert couvreur en climat alpin",
      experience: "10+",
      experienceLabel: "Ans d'expérience",
      image: "https://images.pexels.com/photos/5582599/pexels-photo-5582599.jpeg?auto=compress&cs=tinysrgb&w=800",
      paragraphs: [
        "Présent en <strong>Haute-Savoie (74)</strong> et région de <strong>Genève</strong>, BKR Toiture apporte son expertise des toitures de montagne à votre service. Notre connaissance du climat alpin fait la différence.",
        "Les conditions climatiques extrêmes des Alpes - neige abondante, gel, variations thermiques - exigent un savoir-faire spécifique. Nous maîtrisons les techniques de <strong>couverture adaptées à l'altitude</strong> : étanchéité renforcée, charpentes résistantes aux charges de neige, isolation performante.",
        "De la rénovation de chalets traditionnels aux constructions contemporaines, nous intervenons sur tous types de bâtiments avec la même exigence de qualité et de durabilité face aux éléments."
      ],
    },
    
    // Service area
    serviceArea: {
      title: "Zone d'intervention",
      description: "Artisan couvreur spécialisé en <strong>climat de montagne</strong>, nous intervenons dans toute la <strong>Haute-Savoie (74)</strong>, le bassin annécien, le Genevois français et le <strong>Grand Genève</strong> côté suisse.",
      secondParagraph: "Notre expertise alpine nous permet de répondre aux défis spécifiques des toitures en altitude : résistance à la neige, étanchéité parfaite, isolation thermique renforcée. Nous connaissons les contraintes architecturales locales et les réglementations PLU de chaque commune.",
      areas: [
        "Annecy", "Annemasse", "Thonon-les-Bains", "Genève (Suisse)",
        "Chamonix", "Megève", "La Clusaz", "Cluses",
        "Bonneville", "Sallanches", "Évian-les-Bains", "Saint-Julien-en-Genevois"
      ],
      mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d177770.0073955736!2d6.0282485!3d45.9230965!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x478b8ffa1c0551c5%3A0x42781681620534ba!2sAnnecy%2C%20France!5e0!3m2!1sfr!2sfr!4v1699999999999!5m2!1sfr!2sfr",
      footerAreas: ["Annecy", "Annemasse", "Genève", "Thonon-les-Bains", "Chamonix"],
      footerExtra: "Toute la Haute-Savoie & Grand Genève",
    },
    
    // Structured data
    structuredData: {
      latitude: 45.8992,
      longitude: 6.1294,
      postalCode: "74000",
      addressLocality: "Annecy",
      addressRegion: "Haute-Savoie",
      serviceAreas: ["Annecy", "Annemasse", "Thonon-les-Bains", "Genève", "Chamonix", "Haute-Savoie", "Grand Genève"],
    },
  },
};

// Business constants (shared)
export const BUSINESS = {
  phone: "07.43.46.07.30",
  phoneLink: "tel:+33743460730",
  email: "bkr.toiture@gmail.com",
  name: "BKR Toiture",
};

// Services data (shared but with regional variations)
export const getServices = (regionId) => {
  const isAlpine = regionId === "haute-savoie";
  
  return [
    {
      icon: "Home",
      title: "Couverture",
      description: isAlpine
        ? "Pose de tuiles, ardoises et bac acier adaptés au climat alpin. Couverture résistante aux charges de neige, étanchéité renforcée pour conditions extrêmes. Réparation de toiture endommagée et remplacement de tuiles cassées."
        : "Pose de tuiles, ardoises et zinc. Réparation de fuites, rénovation complète et nettoyage de toiture. Remplacement de tuiles cassées, ardoises déplacées, faîtage et noue. Couverture durable pour votre habitation.",
      items: isAlpine
        ? ["Toiture montagne", "Résistance neige", "Étanchéité alpine", "Tuiles & ardoises"]
        : ["Pose tuiles & ardoises", "Couverture zinc", "Réparation fuite", "Nettoyage toiture"],
      featured: true,
    },
    {
      icon: "Hammer",
      title: "Charpente",
      description: isAlpine
        ? "Charpentes traditionnelles savoyardes et structures contemporaines. Dimensionnement renforcé pour charges de neige, traitement du bois contre l'humidité alpine et les parasites."
        : "Création et rénovation de charpentes traditionnelles. Traitement du bois contre les insectes et champignons, renforcement et consolidation de structures existantes.",
      items: isAlpine
        ? ["Charpente savoyarde", "Charges neige", "Traitement bois", "Rénovation chalet"]
        : ["Charpente traditionnelle", "Traitement du bois", "Renforcement", "Aménagement combles"],
      featured: false,
    },
    {
      icon: "Paintbrush",
      title: "Façade",
      description: isAlpine
        ? "Ravalement de façade résistant aux cycles gel/dégel. Enduits adaptés à l'altitude, réparation de fissures et dégâts climatiques, peinture extérieure longue durée."
        : "Ravalement de façade complet, application d'enduits, réparation de fissures et peinture extérieure. Nettoyage haute pression et traitement anti-mousse.",
      items: isAlpine
        ? ["Ravalement alpin", "Résistance gel", "Enduits montagne", "Réparation fissures"]
        : ["Ravalement façade", "Application enduit", "Réparation fissures", "Peinture extérieure"],
      featured: false,
    },
    {
      icon: "Thermometer",
      title: "Isolation",
      description: isAlpine
        ? "Isolation thermique haute performance pour climat montagnard. Isolation des combles perdus et aménageables, sarking, solutions pour chalets et maisons d'altitude."
        : "Isolation des combles perdus et aménageables. Soufflage de laine minérale, pose de panneaux isolants. Amélioration du DPE et réduction des factures d'énergie.",
      items: isAlpine
        ? ["Isolation combles", "Sarking toiture", "Performance énergétique", "Confort thermique"]
        : ["Isolation combles", "Performance énergétique", "Économies d'énergie", "Confort thermique"],
      featured: false,
    },
    {
      icon: "Droplets",
      title: "Recherche de fuites",
      description: isAlpine
        ? "Votre toit fuit ? Intervention urgente pour tout problème de toiture : recherche de fuites, infiltrations d'eau, dégâts après tempête de neige, gouttières bouchées. Dépannage et bâchage d'urgence."
        : "Problème de toit ? Recherche de fuites par détection précise, réparation d'infiltrations d'eau, dégâts des eaux, gouttières bouchées ou percées. Intervention d'urgence et dépannage rapide.",
      items: isAlpine
        ? ["Recherche fuites", "Urgence toiture", "Infiltration eau", "Dépannage rapide"]
        : ["Recherche fuites", "Problème de toit", "Dégât des eaux", "Urgence toiture"],
      featured: false,
    },
  ];
};

// Why choose us reasons (with regional variations)
export const getReasons = (regionId) => {
  const isAlpine = regionId === "haute-savoie";
  
  return [
    {
      icon: "MapPin",
      title: isAlpine ? "Expert climat alpin" : "Artisan local",
      description: isAlpine 
        ? "Spécialiste des toitures de montagne, nous maîtrisons les contraintes climatiques alpines"
        : "Basé à Le Pecq, nous intervenons rapidement dans tout le 78",
    },
    {
      icon: "ShieldCheck",
      title: "Garantie décennale",
      description: "Tous nos travaux sont couverts par notre assurance décennale",
    },
    {
      icon: "Clock",
      title: "Devis gratuit sous 24h",
      description: "Réponse rapide et devis détaillé sans engagement",
    },
    {
      icon: "Award",
      title: isAlpine ? "Matériaux haute résistance" : "Matériaux professionnels",
      description: isAlpine
        ? "Matériaux sélectionnés pour résister aux conditions extrêmes de montagne"
        : "Nous utilisons uniquement des matériaux de qualité",
    },
    {
      icon: "CheckCircle2",
      title: "Respect des délais",
      description: "Engagement sur les dates de début et fin de chantier",
    },
  ];
};

export default REGIONS;
